import { createContext, useContext, type PropsWithChildren } from "react";

export interface FlightConfig {
  showCalendarPriceRangeTags?: boolean;
}
export const defaultFlightConfig = {
  showCalendarPriceRangeTags: false,
};

const FlightConfigContext = createContext<FlightConfig | undefined>(undefined);

export function useFlightConfig(): FlightConfig {
  const ctx = useContext(FlightConfigContext);
  if (ctx === undefined) {
    console.error(
      "useFlightConfig must be used within a FlightConfigProvider, falling back to default"
    );
    return defaultFlightConfig;
  }
  return ctx;
}
export const FlightConfigProvider = ({
  children,
  context,
}: PropsWithChildren<{ context: FlightConfig }>) => {
  return (
    <FlightConfigContext.Provider value={context}>
      {children}
    </FlightConfigContext.Provider>
  );
};
